exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MedsSummary{margin:20px 0}.MedsSummary-header{font-size:14px;font-weight:500}.MedsSummary-selections{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.MedsSummary-med{width:100%;margin-bottom:0}.MedsSummary-divider{width:284px;height:2px;border-top:1px solid var(--border-primary);margin-bottom:16px}.MedsSummary-divider.bottom{margin-top:20px}", ""]);

// exports
